import { render, staticRenderFns } from "./ServiceNotes.vue?vue&type=template&id=2ac5646d&scoped=true"
import script from "./ServiceNotes.vue?vue&type=script&lang=js"
export * from "./ServiceNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac5646d",
  null
  
)

export default component.exports